import axios from "axios";
import {Toast} from "vant";

const service = axios.create({
    baseURL: "",
    // baseURL: "http://fwmacxdev.api2.hbstoo.com",
    timeout: 60000,
});

service.interceptors.request.use(
    (config) => {
        if (process.env.NODE_ENV === 'production') {
            if (apiDomain) {
                config.baseURL = `${apiDomain}`;
            } else {
                Toast("接口域名获取错误，请联系客服！！！");
            }
        } else {
            config.baseURL = "http://192.168.2.118:10002";
            // config.baseURL = "http://fwmacxdev.api2.hbstoo.com"
        }
        config.headers["Authorization"] = localStorage.getItem("token");
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// service.interceptors.response.use((response) => {
//   if (response.data.code !== 200) {
//     throw new Error(response.data.message);
//   }
//   return response;
// });
export default service;
